<template>
  <base-data-table
    :items="children"
    title="子の情報"
    header-icon="mdi-baby-face-outline"
    :column-widths="['80px', '160px', '90px', '120px', '', '120px']"
  >
    <template #header-cells>
      <th>ID</th>
      <th>セイメイ</th>
      <th>性別</th>
      <th>生年月日</th>
      <th>特記</th>
      <th />
    </template>
    <template #cells="{ row: child }">
      <td>{{ child.id }}</td>
      <td>{{ formatChildName(child) }}</td>
      <td>{{ child.gender }}</td>
      <td>{{ child.birthday }}</td>
      <td>
        <div class="base-data-table-two-line-clamp">
          {{ child.note }}
        </div>
      </td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          @click="$emit('open-detail', child)"
        >
          詳細を開く
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";
import { formatChildName } from "./childName";

export default {
  name: "FaceSheetChildrenInfoTable",
  components: {
    BaseDataTable
  },
  props: {
    children: {
      type: Array,
      default: () => []
    }
  },
  emits: ["open-detail"],
  methods: {
    formatChildName
  }
};
</script>
